import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "../../factories/bao-dialog";


//Viewmodel for the mandator selection dialog in the shiftbooktab mandator tab
class ShiftbookTabMandatorDialog {
    Bao = Bao;
    Dialog: BaoDialog;
    public Model: any;
    MandatorId: KnockoutObservable<string> = ko.observable("");
    Name: KnockoutObservable<string> = ko.observable("");
    MandatorName: KnockoutObservable<string> = ko.observable("");
    Number: KnockoutObservable<string> = ko.observable("");
    SelectedMandator = ko.observable();
    constructor(data: any, dialog: BaoDialog) {
        this.Dialog = dialog;
        $.extend(this, data);
        this.SelectedMandator.subscribe((f: any) => {
            if (f != null) {
                this.Name(f.Name);
                this.Number(f.Number);
                this.MandatorId(f.MandatorId);
            }
        });
    }

    ItemCompleteCheck = (item: any): JQueryPromise<boolean> => {
        let def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
}
export default ShiftbookTabMandatorDialog;